import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UrlService } from './url.service';


@Injectable({
  providedIn: 'root'
})
export class BlobService {

	private svcUrl = '/Blobs';

	constructor(private http: HttpClient, private url: UrlService) {

	}

	downloadBlobForEmailRequest(id: number)
	{
		return this.http.get(this.url.getBaseURL() + this.svcUrl + '/DownloadEmailRequestAttachment/' + id, { responseType: 'blob', observe: 'response' });
	}

}
